import type StatusObject from '@/classes/SubmissionStatuses/StatusObject'
import { StatusThemeVariant } from '@/classes/SubmissionStatuses/StatusThemeVariantEnum'
import { toTitleCase } from '@/classes/SubmissionStatuses/statusUtils'
import {
	type SubmissionAction,
	type SubmissionStatus,
} from '@/classes/SubmissionStatuses/types'

export abstract class BaseInsuranceStatus implements StatusObject {
	submissionStatus: SubmissionStatus

	constructor(submissionStatus: SubmissionStatus) {
		this.submissionStatus = submissionStatus
	}

	getVendorName() {
		return 'NGL'
	}

	getUpdatedAt() {
		return this.submissionStatus.updatedAt
	}

	getActions(): Array<SubmissionAction> {
		return []
	}

	getStatusText() {
		return toTitleCase(this.submissionStatus.status)
	}

	getToolTipText() {
		return {
			title: this.getVendorName() + ' ' + this.getStatusText(),
			body: '',
		}
	}

	getThemeVariant() {
		return StatusThemeVariant.INACTIVE
	}
}
